<template>
	<div class="content-wrapper">
		<!-- Content -->

		<div class="container flex-grow-1 container-p-y">
			<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
				<div class="d-flex flex-column justify-content-center">
					<h4 class="mb-1">Liste de vos formations</h4>
					<p class="mb-0">Vous pouvez voir toutes vos formations ici</p>
				</div>
				<div class="d-flex align-content-center flex-wrap gap-4">
					<router-link to="/trainings/create">
						<button type="submit" class="btn btn-primary">Commander une formation</button>
					</router-link>
				</div>
			</div>

			<div class="col-lg-12">
				<div class="card h-100">
					<div class="card-body pb-0">
						<form class="dt_adv_search">
							<div class="row">
								<div class="col-12">
									<div class="row g-5">
										<div class="col-8 col-sm-8 col-lg-8">
											<div class="form-floating form-floating-outline">
												<input
													type="text"
													class="form-control dt-input dt-full-name"
													data-column="1"
													placeholder="11.2.6.2"
													data-column-index="0"
													v-model="search.content"
													@input="applyFilters"
													autocomplete="off"
												/>
												<label>Recherche par nom, formation</label>
											</div>
										</div>

										<div class="col-4 col-sm-4 col-lg-4">
											<div class="form-floating form-floating-outline">
												<select id="defaultSelect" class="form-select" v-model="search.status" @change="applyFilters">
													<option></option>
													<option value="in_progress">En cours</option>
													<option value="succeeded">Terminées</option>
													<option value="failed">Echouées</option>
												</select>
												<label>Status</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
					<div class="table-responsive">
						<table class="table table-borderless">
							<thead>
								<tr class="border-bottom">
									<th class="bg-transparent fs-xsmall">Formation</th>
									<th class="bg-transparent fs-xsmall">Stagiaire</th>
									<th class="bg-transparent fs-xsmall">Type</th>
									<th class="bg-transparent fs-xsmall">Status</th>
									<th class="bg-transparent fs-xsmall">Progression</th>
									<th class="bg-transparent fs-xsmall">Actions</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(trainee, index) in trainees" :key="index">
									<td>
										<div class="d-flex justify-content-start align-items-center">
											<div class="avatar avatar me-4">
												<span class="avatar-initial rounded-circle bg-label-primary">
													<i class="ri-flight-takeoff-line"></i>
												</span>
											</div>
											<div>
												<h6 class="mb-0 text-truncate">Formation {{ trainee.formationName }}</h6>
												<p class="text-truncate mb-0">{{ formatRelativeDate(trainee.createdAt) }}</p>
											</div>
										</div>
									</td>
									<td>
										{{ trainee.user.firstName }} {{ trainee.user.lastName }}
									</td>
									<td>
										<span 
											v-if="trainee.type === 'renewal'"
										>
											Périodique
										</span>
										<span v-else>
											Initiale
										</span>
									</td>
									<td>
										<span :class="getStatusInfo(trainee.status).class">
											{{ getStatusInfo(trainee.status).text }}
										</span>
									</td>
									<td>
										<div class="progress">
											<div
												class="progress-bar"
												role="progressbar"
												:style="{ width: calculateProgress(trainee) + '%' }"
												:aria-valuenow="calculateProgress(trainee)"
												aria-valuemin="0"
												aria-valuemax="100">
											</div>
										</div>
									</td>
									<td>
										<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="goToTraineeTimeline(trainee._id)" data-bs-toggle="tooltip" title="Suivre la progression" v-if="trainee.status !== 'pending'">
											<i class="ri-eye-line ri-22px"></i>
										</a>
										<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" @click="downloadCertificate(trainee._id)" v-if="trainee.status === 'succeeded'" data-bs-toggle="tooltip" title="Télécharger l'attestation">
											<i class="ri-file-download-fill ri-22px"></i>
										</a>
										<a href="javascript:void(0);" class="btn btn-sm btn-icon btn-text-secondary rounded-pill me-1 waves-effect waves-light" v-if="trainee.status !== 'succeeded' && trainee.status !== 'failed' && trainee.status !== 'pending'" @click="resentTraineeInvitationEmail(trainee._id, trainee.user.email)" data-bs-toggle="tooltip" title="Renvoyer l'email d'invitation">
											<i class="ri-loop-right-fill ri-22px"></i>
										</a>
									</td>
								</tr>
							</tbody>
						</table>
						<div class="row mt-5" v-if="pagination.totalEntries > 5">
							<div class="col-sm-12 col-md-6">
								<div class="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite" style="padding-left: 15px;margin: 10px;">
									Affichage de {{ pagination.totalEntries }} formations
								</div>
							</div>
							<div class="col-sm-12 col-md-6 d-flex justify-content-end" style="padding-right: 40px;">
								<div class="pagination-container">
									<ul class="pagination">
										<!-- Bouton Précédent -->
										<li :class="['page-item', { disabled: pagination.page === 1 }]" @click="changePage(pagination.page - 1)">
											<a class="page-link">
												<i class="ri-arrow-left-s-line"></i>
											</a>
										</li>

										<!-- Pages dynamiques (affichage par groupe de 3) -->
										<li v-for="page in visiblePages" :key="page" :class="['page-item', { active: page === pagination.page }]" @click="changePage(page)">
											<a class="page-link">{{ page }}</a>
										</li>

										<!-- Bouton Suivant -->
										<li :class="['page-item', { disabled: pagination.page + 3 > pagination.totalPages }]" @click="changePage(pagination.page + 1)">
											<a class="page-link">
												<i class="ri-arrow-right-s-line"></i>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- SUCCESS MODAL -->
			<div class="modal fade" id="editUser" tabindex="-1" aria-hidden="true" v-show="modalData">
				<div class="modal-dialog modal-dialog-centered1 modal-simple modal-add-new-cc">
					<div class="modal-content">
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						<div class="modal-body p-0">

							<div class="text-center mb-6">
								<CheckIcon />
								<p class="mt-5">Un nouvel email pour suivre la formation a été envoyé à {{ modalData }}</p>
							</div>							
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- / Content -->
		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";
import moment from "moment";
import "moment/locale/fr";
import CheckIcon from '@/components/CheckIcon.vue';

import { Tooltip } from 'bootstrap'

moment.locale("fr");

export default {
	name: "TrainingList",

	components: { CheckIcon },

	data() {
		return {
			stats: null,
			trainees: [],
			modalData: null,
			search: {
				content: "",
				status: "",
			},
			pagination: {
				page: 1,
				limit: 10, // Nombre d'éléments par page
				totalEntries: 0,
				totalPages: Math.ceil(99 / 10) // Calculé dynamiquement
			}
		};
	},

	computed: {
		visiblePages() {
			const start = Math.floor((this.pagination.page - 1) / 3) * 3 + 1;
			const end = Math.min(start + 2, this.pagination.totalPages);
			return Array.from({ length: end - start + 1 }, (_, i) => start + i);
		},
		// Calcul du premier élément affiché
		startEntry() {
			return (this.pagination.page - 1) * this.pagination.limit + 1;
		},
		// Calcul du dernier élément affiché
		endEntry() {
			return Math.min(this.pagination.page * this.pagination.limit, this.pagination.totalEntries);
		}
	},

	methods: {
		getStatusInfo(status) {
			if (status === "succeeded") {
				return {
					text: 'Terminé',
					class: 'badge bg-label-success rounded-pill'
				};
			}
			if (status === "registered") {
				return {
					text: 'Inscrit',
					class: 'badge bg-label-primary rounded-pill'
				};
			}
			if (status === "in-progress" || status === "chapter-quiz" || status === "final-quiz") {
				return {
					text: 'En cours',
					class: 'badge alert-warning rounded-pill'
				};
			}
			if (status === "pending") {
				return {
					text: 'En attente de validation',
					class: 'badge alert-warning rounded-pill'
				};
			}
			if (status === "failed") {
				return {
					text: 'Echouée',
					class: 'badge bg-label-danger rounded-pill'
				};
			}
			return {
				text: status,
				class: 'badge bg-label-primary rounded-pill'
			};
		},

		calculateProgress(trainee) {
			if (!trainee.totalChapters || trainee.totalChapters === 0) return 0;
				return Math.min(100, Math.round((trainee.currentChapter / trainee.totalChapters) * 100));
		},
	
		formatRelativeDate(date) {
			return moment(date).fromNow(); // Affiche "il y a 3 semaines"
		},

		goToTraineeTimeline(traineeId) {
			this.$router.push(`/trainings/timeline-trainee/${traineeId}`);
		},

		async fetchTrainees() {
			try {
				const params = {
					page: this.pagination.page,
					limit: this.pagination.limit,
					content: this.search.content || undefined,
					status: this.search.status || undefined
				};

				// Appel API avec les filtres et pagination
				const response = await HTTP.get("/trainings/trainees", { params });

				// Mise à jour des données
				this.trainees = response.data.trainees;
				this.stats = response.data.stats;

				this.pagination.totalEntries = response.data.pagination.totalEntries;
				this.pagination.totalPages = response.data.pagination.totalPages;
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		async downloadCertificate(trainingId) {
			try {
				// Appel API pour récupérer le PDF en base64
				const response = await HTTP.post(`/certificates/download`, { trainingId });

				if (response.data?.base64) {
					// Convertir la base64 en un Blob et créer un lien de téléchargement
					const byteCharacters = atob(response.data.base64);
					const byteNumbers = new Array(byteCharacters.length);
					for (let i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					const byteArray = new Uint8Array(byteNumbers);
					const blob = new Blob([byteArray], { type: 'application/pdf' });

					// Créer un lien pour le téléchargement
					const link = document.createElement('a');
					link.href = URL.createObjectURL(blob);
					link.download = `attestation_${trainingId}.pdf`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				} else {
					throw new Error("Fichier non disponible.");
				}
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || 
					"Une erreur est survenue, merci de contacter contact@pika-aero.com";
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		async resentTraineeInvitationEmail(trainingId, email) {
			try {
				await HTTP.post("/trainings/resent-invitation-email", { trainingId });

				this.modalData = email;

				const modalElement = document.getElementById("editUser");
				let modal = window.bootstrap.Modal.getInstance(modalElement);

				if (!modal) {
					modal = new window.bootstrap.Modal(modalElement);
				}

				modal.show();

				// Wait and close
				setTimeout(() => {
					modal.hide();
				}, 2000)
			} catch (error) {
				// Gestion des erreurs
				const errorMessage = error?.response?.data?.message || 
					"Une erreur est survenue, merci de contacter contact@pika-aero.com";
				alert(errorMessage);
				console.error("Erreur API:", error);
			}
		},

		// Méthode pour mettre à jour la page et relancer la recherche
		changePage(newPage) {
			if (newPage > 0 && newPage <= this.pagination.totalPages) {
				this.pagination.page = newPage;
				this.fetchTrainees(); // Charge les nouvelles données
			}
		},
		// Méthode déclenchée par les inputs de recherche
		applyFilters() {
			this.pagination.page = 1; // Réinitialiser à la première page
			this.fetchTrainees();
		}
	},

	async mounted() {
		await this.fetchTrainees();

		const tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]')
		tooltipTriggerList.forEach((el) => {
			new Tooltip(el)
		})
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}
</style>
